import { SOGetProduct } from '../product/so-get-product';
import {ENInterval} from '../../enums';


export class SOPostPrice {

  constructor(
    public name: string,
    public sku: string,
    public amount: number,
    public trailDays: number,
    public interval: ENInterval,
    public product: SOGetProduct,
    public exRef: string = null,
    public active: boolean = true,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostPrice(
      'name' in params ? params.name : null,
      'sku' in params ? params.sku : null,
      'exRef' in params ? params.exRef : null,
      'amount' in params ? params.amount : null,
      'trailDays' in params ? params.trailDays : null,
      'interval' in params ? params.interval : null,
      'active' in params ? params.active : null,
      'product' in params ? params.product : null,
    );
  }
}
